import React from 'react';
import Container from 'components/UI/Container';
import GalleryFilters from './components/GalleryFilters';
import GalleryComponent from './components/GalleryLayouts/GalleryComponent';
import { ALL_GALLERIES_KEY } from '../constants';

import { withErrorBoundary } from 'components/ErrorBoundary';

function DefaultProjects({
  galleries,
  galleriesContent,
  activeGallery,
  setActiveGallery,
  fadeInAnimation,
  setFadeInAnimation,
}) {
  const setGalleryCallback = payload => {
    setActiveGallery(payload);
    setFadeInAnimation(true);
    const filtersRow = document.getElementById('gallery-filters');
    if (filtersRow) {
      filtersRow.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const onAnimationEnd = () => {
    setFadeInAnimation(false);
  };

  return (
    <>
      <Container id="gallery-filters" padding="Without" margin="None">
        <GalleryFilters
          galleries={galleries}
          active={activeGallery}
          setActive={setGalleryCallback}
        />
      </Container>
      <Container
        id="galleries"
        padding="Without"
        margin="None"
        background="transparent"
        onAnimationEnd={onAnimationEnd}
      >
        <GalleryComponent
          componentName="AllGalleries"
          galleries={galleries}
          active={activeGallery}
          setActive={setGalleryCallback}
          fadeInAnimation={fadeInAnimation}
          {...galleriesContent[ALL_GALLERIES_KEY]}
        />
        {galleries.map(gallery => (
          <GalleryComponent
            key={gallery.id}
            {...gallery}
            active={activeGallery}
            fadeInAnimation={fadeInAnimation}
            {...galleriesContent[gallery.id]}
          />
        ))}
      </Container>
    </>
  );
}

DefaultProjects.displayName = 'DefaultProjects';

export default withErrorBoundary(DefaultProjects);
